<script lang="ts">
import vtkMouseCameraTrackballPanManipulator from '@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballPanManipulator';
import { computed, defineComponent, h } from 'vue';

import { ViewportToolMode } from '@/src/store/contours/types/tool-modes-type';
import { useViewportStateStore } from '@/src/store/contours/viewport-state-store';

import MouseManipulatorTool from './MouseManipulatorTool.vue';

export default defineComponent({
  props: {
    viewId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const viewportStateStore = useViewportStateStore();
    const toolOptions = computed(() => {
      const options = [] as any[];
      options.push({ button: 2 });
      if (
        viewportStateStore.getToolMode(props.viewId) === ViewportToolMode.Pan
      ) {
        options.push({ button: 1 });
      }
      return options;
    });
    return () =>
      h(MouseManipulatorTool, {
        ...props,
        name: 'PanTool',
        manipulatorClass: vtkMouseCameraTrackballPanManipulator,
        options: toolOptions.value,
      });
  },
});
</script>
